import { useState } from "react";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import DeskConfirm from "@/components/crm/DeskConfirm";

/** Retrait d'un projet du CRM uniquement (admins) — le projet reste actif sur les autres modules. */
export default function ProjectDeleteDialog({ project, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const confirm = async (reason) => {
    setBusy(true);
    try {
      await api.delete(`/crm/projects/${project.id}`, { params: { reason } });
      toast.deleted("projet", `${project.reference} · module Commercial`, { participle: "retiré", restoreDetail: project.reference, onUndo: async () => { await api.post(`/crm/projects/${project.id}/restore`); window.dispatchEvent(new Event("ledesk:crm-changed")); } });
      onDeleted?.(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Retrait impossible"); } finally { setBusy(false); }
  };
  return (
    <DeskConfirm open={!!project} danger withReason reasonPlaceholder="Motif de la suppression (obligatoire)" title="Supprimer ce projet du module Commercial ?" confirmLabel="Supprimer le projet" busy={busy} onClose={onClose} onConfirm={confirm} testId="crm-project-delete"
      message={<span data-testid="crm-project-delete-dialog">Le projet <b style={{ color: "#E8E8EC" }}>{project?.name}</b> reste actif sur les autres modules (Tâches, Documents, Blocs, Lots). Ré-ajout possible depuis « Projets hors Commercial ».</span>} />
  );
}
